<script setup lang="ts">
import en_US from '@eci-saas/ui/locale/en_US'
import zh_CN from '@eci-saas/ui/locale/zh_CN'
import { useThemeStore } from './stores/theme'
import { useUserStore } from './stores/user'

const { isDark } = storeToRefs(useThemeStore())
onMounted(async () => {
  await useUserStore().initializeAuth()
})

const { locale: i18nLocale } = useI18n()
const locale = computed(() => {
  return i18nLocale.value === 'zh-CN' ? zh_CN : en_US
})
</script>

<template>
  <ConfigProvider :locale="locale">
    <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
    <RouterView />
  </ConfigProvider>
</template>
